export default __webpack_public_path__ + "static/media/mug.807fd929.svg";